<template>
    <div class="sidemenu">
        <ul class="uk-list" v-if="this.$store.state.core.user">
            <li v-if="$store.state.core.user.role >= 4"><router-link to="/configuratie"><span uk-icon="icon: cog"></span> <span class="uk-visible@m">Configuratie</span></router-link></li>
            <li v-if="$store.state.core.user.role >= 3"><router-link to="/users"><span uk-icon="icon: users"></span> <span class="uk-visible@m">Gebruikers</span></router-link></li>
            <li><router-link to="/media"><span uk-icon="icon: image"></span> <span class="uk-visible@m">Gallerij</span></router-link></li>
            <li><router-link to="/pages"><span uk-icon="icon: copy"></span> <span class="uk-visible@m">Pagina's</span></router-link></li>
            <li><router-link to="/projects"><span uk-icon="icon: bolt"></span> <span class="uk-visible@m">Projects</span></router-link></li>
        </ul>
        <img class="bottom-logo" src="../assets/logo_white_solo.svg"/>
        <span class="bottom-version">{{$store.state.core.version}}</span>
        <div class="clear"></div>
    </div>
</template>
<script>
export default {
    name:"sideMenu",
}
</script>
<style scoped>
    ul li a {
        display: block;
        width: 100%;
        height: 100%;
    }
    ul li {
        height: 100%;
        margin: 0 !important;
        padding: 1rem !important;
    }
    
</style>


// WEBPACK FOOTER //
// SideMenu.vue?5c43cc18